import { useEffect, useRef, useState } from 'react'
import Box from '../../../../Global/Box'
import { ACTIVATE_NOTIFICATIONS_REPORT } from '../../../../../graphql/Catalog/Reports/reports'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { useMutation } from '@apollo/client'
import ModalContent from '../../../../Global/ModalContent'
import ReportsByUser from '../../../../Global/UserReports/ReportsByUser'

const ReportInfoUser = ({ user, report }) => {
  const refModal = useRef(null)
  const webChannels = ['web', 'web_gestor', 'web_anonymous']

  //STATE FOR LOADING
  const { showLoading, hideLoading } = useLoading()

  //STATE FOR TOGGLE NOTIFICATIONS
  const [toggleEmail, setToggleEmail] = useState(false)
  const [togglePush, setTogglePush] = useState(false)
  const [userId, setUserId] = useState(null)
  const [modalContent, setModalContent] = useState({
    modalId: null,
    size: 'extra',
    title: '',
    content: null,
  })

  //MUTATION FOR ACTIVATE NOTIFICATIONS
  const [activateNotifications] = useMutation(ACTIVATE_NOTIFICATIONS_REPORT)

  //USE EFFECT FOR SET TOGGLE NOTIFICATIONS
  useEffect(() => {
    if (report) {
      setToggleEmail(report.email_notification)
      setTogglePush(report.push_notification)
    }
  }, [report])

  useEffect(() => {
    if (modalContent.modalId) {
      setUserId(user.id)
      document.getElementById(`spanModal${modalContent.modalId}`).click()
    }
  }, [modalContent])

  const handleViewReportsByUser = (e, infoUser) => {
    // setUserId(user.id)
    e.preventDefault()
    setModalContent({
      modalId: 'modalReportsByUser',
      size: 'extra',
      title: 'Reportes por usuario',
      content: <ReportsByUser userId={user.id} userInfo={user} />,
    })
  }

  const handleActivateNotifications = async (type, value) => {
    showLoading()
    try {
      switch (type) {
        case 'EMAIL':
          setToggleEmail(value)
          break
        case 'PUSH':
          setTogglePush(value)
          break
      }

      const { data } = await activateNotifications({
        variables: {
          reportId: report.id,
          typeNotifications: type,
          isActive: value,
        },
      })

      if (data.activateNotificationReport) {
        return toastSweetAlert({
          mode: 'ok',
          message: 'Notificaciones actualizadas correctamente',
        })
      }
    } catch (error) {
      if (type === 'EMAIL') setToggleEmail(!value)
      if (type === 'PUSH') setTogglePush(!value)

      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const handleGetName = (user) => {
    if (!user) return 'N/A'

    const withSpaces = user.name.split(' ')
    if (user?.name && user?.name !== '' && withSpaces.length > 1) {
      return user.name || user.first_name
    }

    if (user?.name && user?.name !== '' && withSpaces.length === 1) {
      return `${user.name} ${user.first_name || ''} ${user.last_name || ''}`
    }
  }

  return (
    <>
      <Box
        title={'Datos del solicitante'}
        classNameHeader="card-header py-1"
        content={
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6 col-xl-6 mb-3">
              <span className="title-details">Nombre</span>
              <br />
              {report?.channel_capture === 'tlajochat' ? (
                report?.UserTlajoChatOfReport?.name || 'N/A'
              ) : (
                <span
                  className="content-details view-reports-users"
                  onClick={(e) => handleViewReportsByUser(e, user)}
                >
                  {user?.name}
                </span>
              )}
            </div>
            <div
              className={`col-12 col-md-6 col-lg-6 col-xl-6 mb-3 ${
                report?.channel_capture === 'tlajochat' ? 'invisible' : ''
              }`}
            >
              <span className="title-details">Correo</span>
              <br />
              <span className="content-details">{user?.email || 'N/A'}</span>
            </div>
            <div className="col-12 col-md-3 col-lg-3 col-xl-3 mb-3">
              <span className="title-details">Teléfono</span>
              <br />
              <span className="content-details">
                {report?.channel_capture === 'tlajochat'
                  ? report?.UserTlajoChatOfReport?.from || 'N/A'
                  : user?.phone}
              </span>
            </div>
            <div className="col-12 col-md-3 col-lg-3 col-xl-3 mb-3">
              <span className="title-details">Canal aviso</span>
              <br />
              <span className="content-details">
                {webChannels.includes(report.channel_capture)
                  ? 'web'
                  : report?.channel_capture
                  ? report.channel_capture
                  : 'N/A'}
              </span>
            </div>
            {report?.channel_capture !== 'tlajochat' && (
              <>
                <div className="col-12 col-md-3 col-lg-3 col-xl-3 mb-3">
                  <span className="title-details">Notificaciones Email</span>
                  <br />
                  <span className="content-details">
                    <span
                      onClick={() =>
                        handleActivateNotifications('EMAIL', !toggleEmail)
                      }
                    >
                      {toggleEmail ? (
                        <i class="fas fa-toggle-on fa-lg"></i>
                      ) : (
                        <i class="fas fa-toggle-off fa-lg"></i>
                      )}
                    </span>
                  </span>
                </div>
                <div className="col-12 col-md-3 col-lg-3 col-xl-3 mb-3">
                  <span className="title-details">Notificaciones Push</span>
                  <br />
                  <span className="content-details">
                    <span
                      onClick={() =>
                        handleActivateNotifications('PUSH', !togglePush)
                      }
                    >
                      {togglePush ? (
                        <i class="fas fa-toggle-on fa-lg"></i>
                      ) : (
                        <i class="fas fa-toggle-off fa-lg"></i>
                      )}
                    </span>
                  </span>
                </div>
                <div className="col-12 mb-3">
                  <span className="title-details">Dirección</span>
                  <br />
                  <span className="content-details">
                    {user?.address || 'N/A'}
                  </span>
                </div>
                {webChannels.includes(report.channel_capture) && (
                  <div className="col-12 ">
                    <span className="title-details">
                      Reporte registrado por
                    </span>
                    <br />
                    <span className="content-details">
                      {report.UserRegisterOfReport &&
                        handleGetName(report.UserRegisterOfReport)}
                    </span>
                  </div>
                )}
              </>
            )}
          </div>
        }
      />

      <span
        id={`spanModal${modalContent.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modalContent.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModal}
      ></span>

      <ModalContent
        idModal={modalContent.modalId}
        title={modalContent.title}
        size={modalContent.size}
        onClose={() => {
          setModalContent({
            title: '',
            content: null,
            modalId: null,
            size: 'extra',
          })

          setUserId(null)
        }}
        content={modalContent.content}
      />
    </>
  )
}

export default ReportInfoUser
